
import styles from "./Textarea.module.css";

export interface TextareaProps {
  inputId: string;
  disabled?: boolean;
  placeholder?: string;
  maxLength?: number;
  cols?: number;
  rows?: number;
  resizable?: boolean;

  value: string;
  onChange: (value: string) => void;
}

export default function Textarea(props: TextareaProps) {
  return (
    <textarea
      id={props.inputId}
      className={`${styles.textarea} ${!props.resizable ? styles.noresize : ''}`}
      disabled={props.disabled}
      maxLength={props.maxLength}
      autoComplete="off"
      value={props.value}
      rows={props.rows}
      cols={props.cols}
      onChange={v => props.onChange(v.target.value)}
    >
    </textarea>
  )
};
